// src/app/services/favicon.service.ts
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root' // Questo lo rende disponibile a livello radice per le app standalone
})
export class FaviconService {
  private renderer: Renderer2;
  private link: HTMLLinkElement | null = null;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setFavicon(iconUrl: string): void {
    if (!this.link) {
      this.link = this.renderer.selectRootElement('#appFavicon') as HTMLLinkElement;
      if (!this.link) {
        // Se il link con ID 'appFavicon' non esiste, creane uno
        this.link = this.renderer.createElement('link');
        this.renderer.setAttribute(this.link, 'id', 'appFavicon');
        this.renderer.setAttribute(this.link, 'rel', 'icon');
        this.renderer.setAttribute(this.link, 'type', 'image/x-icon');
        this.renderer.appendChild(this.renderer.selectRootElement('head'), this.link);
      }
    }
    this.renderer.setAttribute(this.link, 'href', iconUrl);
  }
}